<template>
  <div>
    <ts-loading-banner :loading="loading_comment">
      <ts-card>
        <ts-card-wrapper>
          <a
            href="#"
            v-if="current_page !== last_page"
            @click.prevent="fetchComment"
            >{{ $t('homework.viewMoreComment') }}</a
          >
          <ul
            ref="container"
            id="container"
            :style="{ 'max-height': maxHeight }"
          >
            <li v-for="comment in resources" :key="comment.id" class="mt-2">
              <display-comment class="mb-2" :record="comment" />
              <ul class="border-reply">
                <li v-for="co in comment.children" :key="co.id">
                  <display-comment
                    class="mb-2"
                    width="30px"
                    height="30px"
                    :record="co"
                  />
                </li>
                <li>
                  <input-private-comment
                    class="mt-2"
                    width="30px"
                    height="30px"
                    v-if="comment.is_reply"
                    :referenceId="comment.id"
                    :id="studentHomeworkId"
                  />
                </li>
              </ul>
            </li>
          </ul>
          <input-private-comment :id="studentHomeworkId" class="mt-2" />
        </ts-card-wrapper>
      </ts-card>
    </ts-loading-banner>
  </div>
</template>

<script>
import InputPrivateComment from './component/input-comment'
import DisplayComment from './component/display-comment'
import { mapState } from 'vuex'
export default {
  props: {
    maxHeight: {
      type: Number | String,
      default: '30vh'
    },
    studentHomeworkId: {
      type: Number,
      required: true
    }
  },
  components: {
    InputPrivateComment,
    DisplayComment
  },
  data() {
    return {
      loading_comment: false
    }
  },
  computed: {
    ...mapState('eschool/homeworkCommentPrivate', [
      'resources',
      'total_comment',
      'current_page',
      'last_page'
    ])
  },
  created() {
    this.fetchComment()
  },
  methods: {
    fetchComment() {
      this.loading_comment = true
      this.reset()
      this.$store
        .dispatch(
          'eschool/homeworkCommentPrivate/getComment',
          this.studentHomeworkId
        )
        .then(response => {
          this.loading_comment = false
          this.scrollToEnd()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading_comment = false
        })
    },
    scrollToEnd() {
      var content = this.$refs.container
      content.scrollTop = content.scrollHeight
    },
    reset() {
      this.$store.commit('eschool/homeworkCommentPrivate/RESET_STATE')
    }
  },
  watch: {
    resources: {
      handler() {
        this.scrollToEnd()
      },
      deep: true
    },
    studentHomeworkId: function(value) {
      this.fetchComment()
    }
  }
}
</script>

<style lang="css" scoped>
ul > li > ul {
  margin-left: 40px;
}
.border-reply {
  /* margin-top: -8px; */
  border-left: 1px solid #eaeaea;
  border-bottom-left-radius: 12px;
}
#container {
  max-height: 30vh;
  overflow: scroll;
}
</style>
